var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSectionicon = function SvgSectionicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.6.8a.8.8 0 0 0 .8.8h11.2a.8.8 0 0 0 .8-.8V0H1.6v.8Zm1.6 2.4h9.6a1.6 1.6 0 0 1 1.6 1.6v6.4a1.6 1.6 0 0 1-1.6 1.6H3.2a1.6 1.6 0 0 1-1.6-1.6V4.8a1.6 1.6 0 0 1 1.6-1.6Zm9.6 8V4.8H3.2v6.4h9.6Zm.8 3.2a.8.8 0 0 1 .8.8v.8H1.6v-.8a.8.8 0 0 1 .8-.8h11.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgSectionicon;